// Kapatılamaz sözleşme onay ekranı. Giriş yapmış ve sözleşmeyi onaylamamış YENİ kullanıcıya çıkar.
// Onaylamadan platformda devam edemez (X yok, dışına tıklayınca kapanmaz). Onay = hukuki delil kaydı.
import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { AGREEMENT_ARTICLES, AGREEMENT_TITLE, AGREEMENT_VERSION, AGREEMENT_EFFECTIVE } from "@/lib/agreement";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";

export function AgreementGate() {
  const { user } = useAuth();
  const [needed, setNeeded] = useState(false);
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user?.id) { setNeeded(false); return; }
    (async () => {
      // Herhangi bir onay kaydı (grandfathered dahil) varsa gösterme.
      const { data } = await (supabase as any).from("user_agreements").select("id").eq("user_id", user.id).limit(1);
      setNeeded(!data || data.length === 0);
    })();
  }, [user?.id]);

  const accept = async () => {
    if (!user?.id || !checked || saving) return;
    setSaving(true);
    try {
      const { data: prof } = await supabase.from("profiles").select("full_name, email, phone").eq("id", user.id).maybeSingle();
      const p = prof as { full_name?: string; email?: string; phone?: string } | null;
      const { error } = await (supabase as any).from("user_agreements").insert({
        user_id: user.id, version: AGREEMENT_VERSION,
        full_name: p?.full_name || null, email: p?.email || user.email || null,
        phone: p?.phone || null, user_agent: navigator.userAgent.slice(0, 300),
      });
      if (error && !String(error.message).toLowerCase().includes("duplicate")) throw error;
      setNeeded(false);
      toast.success("Sözleşme onaylandı. Teşekkürler!");
    } catch (e: any) { console.error(e); toast.error(e?.message || "Onaylanamadı, tekrar dene."); }
    finally { setSaving(false); }
  };

  if (!needed) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-3">
      <div className="bg-background rounded-xl max-w-2xl w-full max-h-[92vh] flex flex-col shadow-2xl border">
        <div className="p-4 border-b shrink-0">
          <h2 className="text-lg font-bold flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-primary" />{AGREEMENT_TITLE}</h2>
          <p className="text-xs text-muted-foreground">Sürüm {AGREEMENT_VERSION} • Yürürlük {AGREEMENT_EFFECTIVE} • Devam etmek için okuyup onaylamanız gerekir.</p>
        </div>
        <div className="p-4 overflow-y-auto space-y-2.5 text-sm">
          {AGREEMENT_ARTICLES.map((a, i) => (
            <p key={i} className="text-muted-foreground leading-snug">
              <span className="font-semibold text-foreground">Madde {i + 1} —</span> {a}
            </p>
          ))}
        </div>
        <div className="p-4 border-t space-y-3 shrink-0">
          <label className="flex items-start gap-2 text-sm cursor-pointer select-none">
            <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-1 h-4 w-4 accent-primary" />
            <span>Yukarıdaki sözleşmenin tamamını <strong>okudum, anladım ve kabul ediyorum</strong>.</span>
          </label>
          <Button variant="gradient" className="w-full gap-2" disabled={!checked || saving} onClick={accept}>
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />}
            Onayla ve Devam Et
          </Button>
        </div>
      </div>
    </div>
  );
}
